
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Pelvis_Tile_classification',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Pelvis_Tile_classification.vue